var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white",
    fillOpacity: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8783 17.4771H29.0292V17.4333H19.5417V21.65H25.4993C24.6301 24.1046 22.2946 25.8667 19.5417 25.8667C16.0487 25.8667 13.2167 23.0346 13.2167 19.5417C13.2167 16.0487 16.0487 13.2167 19.5417 13.2167C21.154 13.2167 22.6209 13.8249 23.7378 14.8185L26.7195 11.8368C24.8367 10.0821 22.3183 9 19.5417 9C13.72 9 9 13.72 9 19.5417C9 25.3633 13.72 30.0833 19.5417 30.0833C25.3633 30.0833 30.0833 25.3633 30.0833 19.5417C30.0833 18.8348 30.0106 18.1449 29.8783 17.4771Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2158 14.635L13.6793 17.1751C14.6164 14.8548 16.8861 13.2167 19.542 13.2167C21.1544 13.2167 22.6213 13.8249 23.7381 14.8185L26.7199 11.8368C24.8371 10.0821 22.3187 9 19.542 9C15.493 9 11.9815 11.286 10.2158 14.635Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5415 30.0826C22.2644 30.0826 24.7385 29.0406 26.6091 27.346L23.3465 24.5851C22.2881 25.3868 20.9725 25.8659 19.5415 25.8659C16.7996 25.8659 14.4714 24.1176 13.5944 21.6777L10.1567 24.3263C11.9014 27.7402 15.4444 30.0826 19.5415 30.0826Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8791 17.4764H29.03V17.4326H19.5425V21.6493H25.5001C25.0827 22.8284 24.3242 23.8451 23.3459 24.5857C23.3464 24.5851 23.347 24.5851 23.3475 24.5846L26.6101 27.3455C26.3793 27.5553 30.0841 24.8118 30.0841 19.541C30.0841 18.8341 30.0114 18.1442 29.8791 17.4764Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAbout);
export default __webpack_public_path__ + "static/media/google-about.29e75e377fac72145669bef191f57813.svg";
export { ForwardRef as ReactComponent };